import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var BellSvg = function BellSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.562 3.749H9.438v1.388h1.879v1.242A8.32 8.32 0 0 0 6.08 8.841a8.57 8.57 0 0 0-2.452 6.01v1.606L2 20.749h20l-1.628-4.292V14.85a8.57 8.57 0 0 0-2.452-6.01 8.32 8.32 0 0 0-5.237-2.462V5.137h1.88zM12 7.739c-1.858 0-3.64.75-4.954 2.083a7.17 7.17 0 0 0-2.052 5.03v1.04h14.012v-1.04a7.17 7.17 0 0 0-2.052-5.03A6.95 6.95 0 0 0 12 7.739m7.22 9.54H4.78l-.79 2.082h16.02z",
    clipRule: "evenodd"
  }));
};
export var Bell = function Bell(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: BellSvg
  }));
};